import React from 'react';
import { Provider } from 'react-redux';
import { Route, BrowserRouter, Switch } from 'react-router-dom';

import MainLayoutFullScreen from './pages/MainLayout/MainLayoutFullScreen';

import ROUTES from './config/routes';

import configureStore from './utils/store';
import MainLayoutConstruction from './pages/MainLayout/MainLayoutConstruction';
const { store } = configureStore();

const App = () => {
  return (
    <Provider store={store}>
      <MainLayoutConstruction />
    </Provider>
  );
};

export default App;
